import { useRedux } from '@zapier/toolbox-redux-framework';

import { currentAppVersionEntities } from 'app/developer-v3/selectors';
import * as CliAppDefinition from 'app/entities/CliAppDefinition';

const mapState = state => {
  const versionEntities = currentAppVersionEntities(state);
  const versions = versionEntities.map(versionEntity => ({
    version: CliAppDefinition.selectors.version(versionEntity),
    userCount: CliAppDefinition.selectors.userCount(versionEntity),
  }));

  return { versions };
};

export default function useVersionUserCounts() {
  return useRedux(mapState);
}
